module.exports = __webpack_public_path__ + "img/man-service.5fd8b625.webp";